module.exports = __webpack_public_path__ + "static/media/careproviderpatient.a9fd61d0.png";